import { Component } from '@angular/core';

@Component({
  selector: 'app-section-loader',
  imports: [],
  templateUrl: './section-loader.component.html',
  styleUrl: './section-loader.component.css'
})
export class SectionLoaderComponent {

}
